import { useEffect, useState } from 'react';

const QUERY = '(pointer: coarse)';

/**
 * Whether the main pointer is a finger (spec 272): the JavaScript side of the
 * `pointer-coarse:` variant, for sizes CSS cannot set, such as a virtual
 * list's row height.
 */
export function useCoarsePointer(): boolean {
  const [coarse, setCoarse] = useState(
    () =>
      typeof window !== 'undefined' &&
      typeof window.matchMedia === 'function' &&
      window.matchMedia(QUERY).matches,
  );
  useEffect(() => {
    if (typeof window.matchMedia !== 'function') return;
    const query = window.matchMedia(QUERY);
    const sync = (event: MediaQueryList | MediaQueryListEvent) => {
      setCoarse(event.matches);
    };
    sync(query);
    query.addEventListener('change', sync);
    return () => {
      query.removeEventListener('change', sync);
    };
  }, []);
  return coarse;
}
